import React from 'react';

const Footer = () => {
  return (
    <footer style={{ padding: '5rem 0 3rem', backgroundColor: 'white', boxShadow: '0 -5px 20px rgba(0, 0, 0, 0.03)', color: 'var(--dark)' }}>
      <div className="container">
        <div className="footer-about" style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
          <div className="footer-logo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', marginBottom: '1.5rem' }}>
            <div className="logo-icon" style={{ width: '2.5rem', height: '2.5rem' }}></div>
            <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--dark)' }}>After<span style={{ color: 'var(--primary)', backgroundImage: 'none', WebkitTextFillColor: 'initial' }}>image</span></div>
          </div>
          <p style={{ fontSize: '1.25rem', lineHeight: 1.7, marginBottom: '2.5rem', color: 'var(--gray)' }}>Transforming healthcare by empowering patients and creating incentives for systemic improvement in diagnostic accuracy.</p>
        </div>
        <div className="copyright" style={{ borderTop: '1px solid var(--light-gray)', paddingTop: '2rem', marginTop: '1rem' }}>
          <p style={{ fontSize: '1.1rem', textAlign: 'center', color: 'var(--gray)' }}>&copy; {new Date().getFullYear()} Afterimage. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 